// Setup quill WYSIWYG editor
const toolbarOptions = [
    [ "bold",
        "italic",
        "underline",
        "strike" ], // toggled buttons
    [ "blockquote", "code-block" ],
    [ { list: "ordered" }, { list: "bullet" } ],
    [ { align: [] } ],
    [ "link", "image" ],
    [ "clean" ], // remove formatting button
];

const options = {
    theme: "snow",
    modules: {
        toolbar: {
            container: toolbarOptions,
            handlers: { image: quillImageHandler },
        },
    },
};

export const quill = new Quill(".js-editor", options);

function quillImageHandler() {
    let fileInput = this.container.querySelector("input.ql-image[type=file]");

    if (fileInput === null) {
        fileInput = document.createElement("input");
        fileInput.setAttribute("type", "file");
        fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/jpg");
        fileInput.classList.add("ql-image");
        fileInput.addEventListener("change", () => {
            const files = fileInput.files;
            const range = this.quill.getSelection(true);

            if (!files || !files.length) {
                // No file selected
                return;
            }

            const formData = new FormData();
            formData.append("post_image", files[0]);
            formData.append("action", "guest_post_image");
            formData.append("nonce", guestPostJs.ajax_nonce);

            // Disable the editor while we upload
            quill.enable(false);
            // Add a disabled class to the quill parent so we can style the editor with a loading animation and make it look disabled
            document.querySelector(".fa-spinner").classList.add("show");
            // Disable navigation buttons while image is uploading to Azure blob
            const navBtns = document.querySelectorAll(".ctrl-btn");

            navBtns.forEach(function(navBtn) {
                navBtn.disabled = true;
            });

            jQuery.ajax({
                url: guestPostJs.ajax_url,
                type: "POST",
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    const data = JSON.parse(response);

                    // Enable the editor again
                    quill.enable(true);
                    document.querySelector(".fa-spinner").classList.remove("show");
                    navBtns.forEach(function(navBtn) {
                        navBtn.disabled = false;
                    });

                    // Check for any error messages. Show them if they exist
                    if (typeof data.error !== "undefined") {
                        const error = document.querySelector("span.quill-error");
                        error.innerHTML = data.error;
                        error.classList.add("show");

                        return;
                    }

                    // Insert the uploaded image into the editor
                    quill.editor.insertEmbed(range.index, "image", data.url_path);
                    // Put the mouse cursor next to the new image
                    quill.setSelection(range.index + 1, Quill.sources.SILENT);
                    // Setting the hidden input to the value of the WYSIWYG
                    document.querySelector(".js-description").value = quill.root.innerHTML;
                    // Clear our file input to make room for another image if needed.
                    fileInput.value = "";
                },
                error: function() {
                    // Upload failed. Enable the editor again.
                    quill.enable(true);
                },
            });
        });
        this.container.appendChild(fileInput);
    }
    fileInput.click();
}
